/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Interactive_ModuleInputs */

const en_val_interactive_module = /** @type {(inputs: Val_Interactive_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interactive Module`)
};

const es_val_interactive_module = /** @type {(inputs: Val_Interactive_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Módulo interactivo`)
};

const fr_val_interactive_module = /** @type {(inputs: Val_Interactive_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Module interactif`)
};

const de_val_interactive_module = /** @type {(inputs: Val_Interactive_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interaktives Modul`)
};

const ja_val_interactive_module = /** @type {(inputs: Val_Interactive_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インタラクティブモジュール`)
};

const zh_val_interactive_module = /** @type {(inputs: Val_Interactive_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`交互式模块`)
};

const ar_val_interactive_module = /** @type {(inputs: Val_Interactive_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وحدة تفاعلية`)
};

const id_val_interactive_module = /** @type {(inputs: Val_Interactive_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modul Interaktif`)
};

const it_val_interactive_module = /** @type {(inputs: Val_Interactive_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modulo Interattivo`)
};

const ru_val_interactive_module = /** @type {(inputs: Val_Interactive_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Интерактивный модуль`)
};

const pt_val_interactive_module = /** @type {(inputs: Val_Interactive_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Módulo Interativo`)
};

const ko_val_interactive_module = /** @type {(inputs: Val_Interactive_ModuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인터랙티브 모듈`)
};

/**
* | output |
* | --- |
* | "Interactive Module" |
*
* @param {Val_Interactive_ModuleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_interactive_module = /** @type {((inputs?: Val_Interactive_ModuleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Interactive_ModuleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_interactive_module(inputs)
	if (locale === "es") return es_val_interactive_module(inputs)
	if (locale === "fr") return fr_val_interactive_module(inputs)
	if (locale === "de") return de_val_interactive_module(inputs)
	if (locale === "ja") return ja_val_interactive_module(inputs)
	if (locale === "zh") return zh_val_interactive_module(inputs)
	if (locale === "ar") return ar_val_interactive_module(inputs)
	if (locale === "id") return id_val_interactive_module(inputs)
	if (locale === "it") return it_val_interactive_module(inputs)
	if (locale === "ru") return ru_val_interactive_module(inputs)
	if (locale === "pt") return pt_val_interactive_module(inputs)
	return ko_val_interactive_module(inputs)
});